import app from './app.json';

const enMsg = {
  ...app,
};

export default enMsg;
